<template>
  <v-avatar
    :size="size"
    tile
    class="v-avatar--logo"
  >
    <img :alt="alt" :src="src" />
  </v-avatar>
</template>

<script>
  export default {
    props: {
      alt: {
        type: String,
        default: ''
      },
      src: {
        type: String,
        required: true
      },
      size: {
        type: [Number, String],
        default: 40
      }
    }
  }
</script>

<style lang="stylus">
  .v-avatar--logo
    background-color: white
    img
      // Necessary to scale down images in IE while playing nice in FF
      // See DOHA-1425 and https://stackoverflow.com/questions/41489798/keep-image-ratio-using-max-width-and-max-height-in-ie-11
      flex: 0 0 auto
      object-fit: scale-down
      width: auto
      height: auto
      max-width: 100%
      max-height: 100%
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/AvatarLogo.vue